import React, { createContext, useState, useEffect } from 'react';
import api from '../api'; // Assicurati che il percorso sia corretto

export const FavoritesContext = createContext();

export const FavoritesProvider = ({ children }) => {
    const [favoriteIds, setFavoriteIds] = useState(new Set());
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchFavorites = async () => {
            try {
                const response = await api.get('/reservations/user-favorites', { skipToast: true });
                setFavoriteIds(new Set(response.data.map(item => item._id)));
            } catch (error) {
            } finally {
                setIsLoading(false);
            }
        };

        fetchFavorites();
    }, []);

    return (
        <FavoritesContext.Provider value={{ favoriteIds, setFavoriteIds, isLoading }}>
            {!isLoading && children}
        </FavoritesContext.Provider>
    );
};
